import { useEffect } from "react";
import { useForm } from "react-hook-form";
import SwitchInput from "../shared/Inputs/SwitchInput";
import useCustomer from "../../data/useCustomer";
import LoadingWheel from "../shared/LoadingWheel";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";

export default function AdminEmailTriggers() {
  const { customer, update } = useCustomer();
  const { saveHandlers } = useDefaultCRUDHandlers("Email Triggers");

  const { register, watch, setValue, handleSubmit } = useForm();

  const onSubmit = async (data: any) => {
    update.mutate(
      {
        emailTriggerContactDetails: data.emailTriggerContactDetails,
        emailTriggerPricesGenerated: data.emailTriggerPricesGenerated,
      },
      {
        onSuccess: saveHandlers.onSuccess,
        onError: saveHandlers.onError,
      }
    );
  };

  useEffect(() => {
    if (customer.isLoading || !customer.data?.data) return;
    setValue("emailTriggerContactDetails", customer.data.data.emailTriggerContactDetails ?? false);
    setValue("emailTriggerPricesGenerated", customer.data.data.emailTriggerPricesGenerated ?? false);
  }, [customer.data, customer.isLoading]);

  if (customer.isLoading) return <LoadingWheel />;

  return (
    <div>
      <h1 className="mb-2">Email Triggers</h1>
      <p className="text-sm text-gray-500 mb-4">
        When enabled, an automated email is sent to your primary contact address each time the selected event occurs in the widget.
      </p>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            const newVal = !watch("emailTriggerContactDetails");
            setValue("emailTriggerContactDetails", newVal);
            update.mutate(
              { emailTriggerContactDetails: newVal },
              { onSuccess: saveHandlers.onSuccess, onError: saveHandlers.onError }
            );
          }}
        >
          <div>
            <p className="text-sm font-medium text-gray-900">Contact details entered</p>
            <p className="text-xs text-gray-500">Fires when a customer submits their email and phone number in the widget.</p>
          </div>
          <SwitchInput
            label=""
            register={register}
            registerName="emailTriggerContactDetails"
            watch={watch}
            setValue={setValue}
            classes="pointer-events-none"
          />
        </div>

        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            const newVal = !watch("emailTriggerPricesGenerated");
            setValue("emailTriggerPricesGenerated", newVal);
            update.mutate(
              { emailTriggerPricesGenerated: newVal },
              { onSuccess: saveHandlers.onSuccess, onError: saveHandlers.onError }
            );
          }}
        >
          <div>
            <p className="text-sm font-medium text-gray-900">Prices generated</p>
            <p className="text-xs text-gray-500">Fires when collect and drop-off prices are calculated for a customer's vehicle.</p>
          </div>
          <SwitchInput
            label=""
            register={register}
            registerName="emailTriggerPricesGenerated"
            watch={watch}
            setValue={setValue}
            classes="pointer-events-none"
          />
        </div>
      </form>
    </div>
  );
}
